<script lang="ts">
  import { getUniqueContainerStyles, makePanelOption } from '$lib/helpers/makePanelOption';
  import { onMount } from 'svelte';
  import { type VariationContainerProps } from '$lib/types/contentTypes';
  import { getVariationItem } from '$lib/stores/optimizelyStore';

  export let variationContainer: VariationContainerProps;
  export let pageType: string;
  export let index: number;

  let variationItem: VariationContainerProps['variationsCollection']['items'][0] | undefined;
  let panelOption: ReturnType<typeof makePanelOption>;
  let containerStyles: ReturnType<typeof getUniqueContainerStyles>;

  onMount(async () => {
    variationItem = getVariationItem(variationContainer);

    if (variationItem) {
      panelOption = makePanelOption(variationItem, variationItem.contentType);
      containerStyles = getUniqueContainerStyles(pageType, variationItem.contentType, index);
    }
  });
</script>

{#if panelOption}
  <svelte:component this={panelOption.component} style={containerStyles} {...panelOption.props} />
{/if}
